import useTranslate from '../../i18n/useTranslate'
import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'

export type InitFilesT = {
    documentTopicID: number
    fileList: {
        fileToken: string
        filename: string
        path: string
    }[]
    subTopicPageList?: any
}

export type FormT = {
    nameTH: string
    nameEN: string
    mobilePhone?: string
    email: string
    reason: string
    files: { uploadFileObj: InitFilesT }[]
    status: string
    reasonReject?: string
    result?: string
    departments?: string
    departments_en?: string
    langReason?: string
}

export type ApproveT = {
    email?: string
    nameTH?: string
    nameEN?: string
    updateBy: string
    statusID: number
    reasonReject: string
    departments?: string
    departments_en?: string
    langReason?: string
}
const useApproveExReseacher = () => {
    const t = useTranslate()
    const callApi = useCallApi()

    const put = async (values: ApproveT, userID: string) => {
        const { data } = await callApi.axiosPut<any>({
            url: `${umServinceURL.putResultExResearcher}/${userID}`,
            params: { ...values, subject: t.get('UM.APPROVE-RESEARCHER.SUBJECT_MAIL') },
        })

        return data
    }

    const formatFile = (files: { uploadFileObj: InitFilesT }[]) => {
        const formatLink = files.map((item) => {
            const fileList = item.uploadFileObj.fileList.map((itemList) => ({
                ...itemList,
                path: `${process.env.REACT_APP_UPLOAD}${itemList.path}`,
            }))

            item.uploadFileObj.fileList = fileList

            return item
        })

        return formatLink
    }

    const get = async (userID: string) => {
        const { data } = await callApi.axiosGet<any>({
            url: `${umServinceURL.getRequestExResearcher}/${userID}`,
        })

        const format = {
            userID: data.userID,
            nameTH: data.nameTH,
            nameEN: data.nameEN,
            mobilePhone: data.mobilePhone,
            email: data.username,
            reason: data.reason,
            status: `${data.statusID}`,
            reasonReject: data.reasonReject,
            files: formatFile(data.uploadFile),
            departments: data.departments,
            departments_en: data.departments_en,
        }

        return format
    }

    return { put, get }
}

export default useApproveExReseacher
